import React from 'react';
import { Container, Draggable } from 'react-smooth-dnd';

import { Skill } from '../../model/skill';
import {
    DropResult,
    InnerSoundMeta,
    thereminvoxSoundsDragHandleId,
    ThereminvoxTestingModeProps,
} from '../../model/thereminvox';
import { applyDrag } from '../../utils/thereminvox';

import { ThereminvoxSound } from './ThereminnvoxSound';

interface ThereminvoxSoundsContainerProps extends ThereminvoxTestingModeProps {
    innerSoundsMeta: InnerSoundMeta[];
    setInnerSoundsMeta: (meta: InnerSoundMeta[]) => void;
    isTestingMode?: boolean;
    skill: Skill;
}

export const ThereminvoxSoundsContainer: React.SFC<ThereminvoxSoundsContainerProps> = ({
    innerSoundsMeta,
    setInnerSoundsMeta,
    isTestingMode,
    skill,
    ...testingModeProps
}) => {
    const setInnerSoundMeta = (index: number) => (newMeta: InnerSoundMeta) =>
        setInnerSoundsMeta(innerSoundsMeta.map((meta, i) => (i === index ? newMeta : meta)));
    const onRemoveSound = (index: number) => () => {
        setInnerSoundsMeta([...innerSoundsMeta.slice(0, index), ...innerSoundsMeta.slice(index + 1)]);
    };

    return (
        <Container
            dragHandleSelector={`#${thereminvoxSoundsDragHandleId}`}
            onDrop={(res) => setInnerSoundsMeta(applyDrag(innerSoundsMeta, res as DropResult<InnerSoundMeta>))}
            getChildPayload={(i) => innerSoundsMeta[i]}
        >
            {innerSoundsMeta.map((meta, i) => (
                <Draggable key={meta.id}>
                    <ThereminvoxSound
                        innerSoundMeta={meta}
                        isTestingMode={isTestingMode}
                        setInnerSoundMeta={setInnerSoundMeta(i)}
                        skill={skill}
                        onRemove={onRemoveSound(i)}
                        position={innerSoundsMeta.length - i} // lower sound - lower number
                        {...testingModeProps}
                    />
                </Draggable>
            ))}
        </Container>
    );
};
